import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// allowedRoles: массив roleId которым разрешён доступ.
// Если не передан — доступ для всех авторизованных.
// roleId: 1 = Pedagog, 2 = Administrator, null = Student
export const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, userRole } = useAuth();

  if (!isAuthenticated) return <Navigate to="/login" />;

  if (allowedRoles && !allowedRoles.includes(userRole)) {
    if (userRole === 1) return <Navigate to="/teacher" />;
    if (userRole === 2) return <Navigate to="/admin" />;
    return <Navigate to="/dashboard" />;
  }

  return children;
};
